export default __webpack_public_path__ + "static/mobileApplicationDevelopmentBanner-fe07a5b45047283d6fe088b2fe3514c7.svg";